import { useRef } from "react";

import Card from "../ui/Card";
import classes from "./NewTaxrateForm.module.css";

export default function NewCostAndRevenueForm(props) {
    const nameInputRef = useRef();

    function submitHandler(event) {
        event.preventDefault();
        const enteredName = nameInputRef.current.value;
        const newData = {
            name: enteredName
        };
        props.onStoreNew(newData);
    }

    return <Card className={classes.card}>
        <form className={classes.form} onSubmit={submitHandler}>
            <div className={classes.control}>
                <label htmlFor='title'>Name</label>
                <input type='text' required id='name' ref={nameInputRef} />
            </div>
            <div className={classes.action}>
                <button>Submit</button>
            </div>
        </form>
    </Card>
}